import { render, staticRenderFns } from "./Contenu.vue?vue&type=template&id=28dd4460&"
import script from "./Contenu.vue?vue&type=script&lang=js&"
export * from "./Contenu.vue?vue&type=script&lang=js&"
import style0 from "./Contenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports